import { Row, Table } from "antd";
import React from "react";

import { AuditAppointmentsColumns } from "audit/constants";
import variables from "../../../_variables.scss";
import "./AuditAppointments.scss";
import { IAuditAppointment } from "audit/models";

interface AuditAppointmentsProps {
  auditAppointments: IAuditAppointment[];
}

export const AuditAppointments = ({ auditAppointments }: AuditAppointmentsProps) => {
  const tblRef: Parameters<typeof Table>[0]["ref"] = React.useRef(null);
  const tableColumns = AuditAppointmentsColumns.map((item) => ({
    ...item,
  }));

  return (
    <Row data-testid='auditAppointments'>
      <Table
        columns={tableColumns}
        dataSource={auditAppointments}
        className='audit-appointments-table'
        ref={tblRef}
        rowKey='id'
        pagination={false}
        scroll={{ y: variables.defaultComponentHeight }}
      />
    </Row>
  );
};
